<template>
  <div>
    <language-list
      v-if="isLang === true"
      v-model="langCurrent"
      :name="item.id"
    />
    <div class="row">
      <template v-for="field in fields">
        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-if="
            field.ishide !== true &&
            field.type === 'field' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <fg-input
            :type="field.textType"
            :label="field.label"
            v-model="item[field.key]"
          ></fg-input>
        </div>

             <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-if="
            field.ishide !== true &&
            field.type === 'mask' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
       
          <fg-input type="text"     :label="field.label"  v-mask="field.mask"  :placeholder="field.placeholder"  v-model="item[field.key]" />
        </div>
        <div
           :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'img' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
         <a target="_blank" v-if="field.download && item[field.download]" :href="item[field.download]">Скачать </a>
          <img-upload v-model="item[field.key]" :title="field.label" />
         
        </div>
        <div
           :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'select' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <selector
               :prefix="field.prefix"
            v-model="item[field.key]"
            :title="field.label"
            :modal="field.modal"
            :selectKey="field.selectKey"
          />
        </div>
        <div
           :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'selects' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >

          <selectors
            :selectKey="field.selectKey"
            v-model="item[field.key]"
            :title="field.label"
            :modal="field.modal"
            :prefix="field.prefix"
          />
        </div>
        <div
            :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'checkbox' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <checkbox v-model="item[field.key]" color="#ffc107">{{
            field.label
          }}</checkbox>
        </div>

        <div
        :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'static_radio' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <radio-list
            :title="field.label"
            :items="field.items"
            :name="field.key"
            v-model="item[field.key]"
            color="#ffc107"
            >{{ field.label }}</radio-list
          >
        </div>

        <div
           :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'object' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <h4>{{ field.label }}</h4>
          <sub-field-list
            v-model="item[field.key]"
            :subFields="field.subFields"
          />
        </div>

        <div
         :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'location' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <label>{{ field.label }}</label>

          <location
            :city="item[field.key]"
            :region="
              item.region && item.region.parent && item.region.parent.id
                ? item.region.parent.id
                : null
            "
            v-model="item[field.key]"
          />
        </div>

        <div
          :class="field.col ? field.col : 'col-12'"
          v-show="
            !field.langKey || (field.langKey && field.langKey === langCurrent)
          "
          v-else-if="
            field.ishide !== true &&
            field.type === 'textarea' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <div class="form-group">
            <label class="control-label">{{ field.label }}</label>
            <textarea class="form-control" v-model="item[field.key]" />
          </div>
        </div>
        <div
            :class="field.col ? field.col : 'col-12'"
          v-else-if="
            field.ishide !== true &&
            field.type === 'html' &&
            field.isMultiLang !== true
          "
          :key="field.key"
        >
          <div
            v-show="
              !field.langKey || (field.langKey && field.langKey === langCurrent)
            "
          >
            <label class="control-label">{{ field.label }}</label>

            <quill-editor v-model="item[field.key]" :options="editorOption" />
          </div>
        </div>
    
      </template>
    </div>
  </div>
</template>
<script>
/**Меняю добавление модалку */
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "FieldsList",
  data: () => ({
    langCurrent: "ru",
    editorOption: {},
  }),
  components: {
    "language-list": () => import("../Filters/LanguageList"),
    selector: () => import("../Inputs/Selector"),
    "radio-list": () => import("../Filters/RadioList"),
    selectors: () => import("../Inputs/Selectors"),
    "img-upload": () => import("../Inputs/ImgUpload"),
    "sub-field-list": () => import("./SubFieldList"),
    location: () => import("../Location"),
    quillEditor,
  },
  props: ["item", "fields"],
  computed: {
    isLang: {
      get() {
        for (let i = 0; i < this.fields.length; i++) {
          if (this.fields[i].isMultiLang) {
            return true;
          }
        }
        return false;
      },
    },
  },
  created() {

    for (let i = 0; i < this.fields.length; i++) {

      if (this.fields[i].type === "hidden") {
        this.item[this.fields[i].key] = this.fields[i].value;
      }
    }
  },
};
</script>

